define('bizzabo/views/NotificationView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/consts',
    'hbars!bizzabo/templates/notification'
], function(
    $,
    Backbone,
    _,
    Consts,
    template
    ) {

    var NotificationView = Backbone.View.extend({
        tagName : 'section',
        className : 'notification',

        events : {
            "click a.ok" : "formOkClicked",
            "click a.cancel" : "formCancelClicked",
            'click a.closeNotificationBtn' : 'formCloseClicked'
        },

        initialize : function() {
            _.bindAll(this, 'close');
            if (this.options) {
                this.model = new NotificationModel(this.options);
            }
        },

        hideAndRemove : function() {
            var thisView = this;
            this.$el.slideUp('fast', function() {
                thisView.remove();
            });
        },

        show : function() {
            var thisView = this;
            this.$el.slideDown('fast', function() {
                if (thisView.model.get("autoHide")) {
                    var timeoutTillHide = thisView.model.get("hideAfter");
                    window.setTimeout(thisView.close, timeoutTillHide);
                }
            });
        },

        render : function() {
            var html = template(this.model.attributes);
            this.$el.html(html);
            return this;
        },

        formOkClicked : function() {
            this.closeAndCallBack(this.model.get("okCallBack"));
        },

        formCancelClicked : function() {
            this.closeAndCallBack(this.model.get("cancelCallBack"));
        },

        formCloseClicked : function() {
            this.close();
        },

        closeAndCallBack : function(cb) {
            this.hideAndRemove();
            cb && cb();
        },

        close : function() {
            this.closeAndCallBack(this.model.get("closeCallBack"));
        }
    });

    var NotificationModel = Backbone.Model.extend({
        defaults : {
            msg : "Something went wrong. Sorry for that.",
            errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.ERROR,
            autoHide : false,
            hideAfter : 5000, // in millis
            showOkBtn : false,
            showCancelBtn : false,
            okBtnText : "Dismiss",
            cancelBtnText : "Cancel",
            okCallBack : undefined,
            cancelCallBack : undefined,
            showCountDown : false
        }
    });

    return NotificationView;

});
